import { AydenAPM } from './components/AdyenAPM/AdyenAPM';
import { useCheckout } from '../../../../hooks/use-checkout';
import { EBEPaymentMethodsName } from '../../../../contracts';
import { AdyenCardContainer } from './components/AdyenCardContainer/AdyenCardContainer';

export function AydenPaymentElement() {
  const { selectedPaymentMethod } = useCheckout();
  if (selectedPaymentMethod?.paymentMethodName === EBEPaymentMethodsName.card) {
    return <AdyenCardContainer />;
  }
  return <AydenAPM />;
}
